import { Router } from '@angular/router';
import { AdminService } from '@app/features/admin/services/admin.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../features/admin/services/admin.service";
var AdminNavigationService = /** @class */ (function () {
    function AdminNavigationService(router, adminService) {
        this.router = router;
        this.adminService = adminService;
        this.redirectChecked = false; // stops multiple loops
        this.lastResponse = null; // cache API response
        this.hasRedirectedToCustomers = false;
    }
    AdminNavigationService.prototype.checkAndRedirect = function () {
        var _this = this;
        // If we’ve already handled redirect, don’t repeat
        if (this.redirectChecked) {
            return Promise.resolve(null);
        }
        //  Mark as checked to stop loops
        this.redirectChecked = true;
        //  Use cached response if available
        var apiCall = this.lastResponse ? Promise.resolve(this.lastResponse) : this.adminService.clientsPaymentMethod().toPromise();
        return apiCall
            .then(function (resp) {
            _this.lastResponse = resp;
            if (resp.contractView) {
                return 'contractView';
            }
            else if (resp.invoicePaymentRequired) {
                return 'invoicePaymentRequired';
            }
            else if (resp.ddRequired) {
                return 'ddRequired';
            }
            else if (resp.ccRequired) {
                return 'ccRequired';
            }
            else if (resp.achRequired) {
                return 'achRequired';
            }
            // condition: all flags false but isNewAdmin true
            var current = window.location.pathname;
            // If user is on either of these pages, DO NOT redirect to /customers
            if (current === '/setup/payment_required/success' ||
                current === '/setup/contract_summary/payment_method') {
                return null;
            }
            if (!resp.contractView &&
                !resp.ddRequired &&
                !resp.invoicePaymentRequired &&
                !resp.ccRequired &&
                !resp.achRequired &&
                resp.isNewAdmin && // new admin onboarding
                !_this.hasRedirectedToCustomers && // not redirected before
                (current === '/' || current == '/setup/payment_required/invoice_list' || current == '/setup/contract_summary/payment_detail' || current == '/setup/show_smart_debit') // not redirected befor) 
            ) {
                _this.hasRedirectedToCustomers = true;
                window.location.replace('/customers');
                return null;
            }
            return null;
        })
            .catch(function () { return null; });
    };
    AdminNavigationService.ngInjectableDef = i0.defineInjectable({ factory: function AdminNavigationService_Factory() { return new AdminNavigationService(i0.inject(i1.Router), i0.inject(i2.AdminService)); }, token: AdminNavigationService, providedIn: "root" });
    return AdminNavigationService;
}());
export { AdminNavigationService };
